export const STYLES = {
  sectionHeader: { marginBottom: 16 },
  fullWidth: { width: '100%' },
  cardBody: { height: '100%' },
  emptyState: { textAlign: 'center', padding: '40px 0' },
};

export const GUTTER = {
  rate: [8, 8],
  section: [16, 24],
};
